/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useState, useEffect } from "react";
import API from "../../utils/API";
import Html from "../../utils/Html";
import Btn from "./main.content.btn";
import CreateChart from "./create.chart";
import SelectLimit from "./main.content.select.limit";
import SelectPage from "./main.content.select.page";
import TableContent from "./main.content.table";
import ModalViewStaff from "./modal.view.staff";
import BtnExport from "./main.content.btn.export";
import ModalExport from "./modal.export";
import ModalDownload from "./modal.download";

export default function MainContent({
  userData,
  defaultFilters,
  setClearFilters,
  showFullnameAndPosition }) {
  const userID = userData.idu;
  const defaultData = {
    data: {},
    summary_total: 0,
    total_page: 0,
    active_page: 1,
    status: "",
    err: 0,
    err_msg: "" };

  const [filters, setFilters] = useState(defaultFilters);
  const [reqData, setReqData] = useState(defaultData);
  const [showChart, setShowChart] = useState(false);

  useEffect(() => {
    setReqData((prev) => ({ ...prev, status: "processing" }));

    setShowChart(false); // hide chart before re-fetch
    const fetchData = async () => {
      try {
        const res = await API.post("org/data", {
          params: ({ userID, filters }) });

        const decrypt = (res?.data);
        if (decrypt?.status === "success") {
          setReqData(decrypt);
          setTimeout(() => setShowChart(true), 50); // delay chart render
        } else {
          setReqData({
            status: "",
            err: 1,
            err_msg: `Failed: ${decrypt?.err_msg || "Unknown error"}` });
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setReqData({ status: "", err: 1, err_msg: String(err) });
      }
    };

    fetchData();
  }, [filters]);

  let content = [];

  if (reqData.err === 1) {
    content.push(
      <div key="text-error-content" className="text-error">
        Fetch request error: {reqData.err_msg}
      </div>
    );
  } else if (reqData.status != "success") {
    content.push(
      <div key="preloading-content">
        <Html.Preloading
          addon={{
            css: {
              position: "absolute",
              top: "50px",
              left: "0",
              right: "0",
              bottom: "0",
              margin: "auto" } }}
        />
      </div>
    );
  } else {
    const hasFilters =
      (filters.branch && filters.branch.length > 0) ||
      (filters.department && filters.department.length > 0) ||
      (filters.name && filters.name.length > 0) ||
      filters.select_page ||
      filters.select_limit;

    if (reqData.data.summary_total > 0) {
      content.push(
        <div key="outer-org-table" id="outer-org-table">
          <div id="org-table" style={hasFilters ? {} : { display: "none" }}>
            <div className="row" style={{ position: "relative" }}>
              <div className="title">
                Total:{" "}
                <span id="table-total__number">
                  {reqData.data.summary_total}
                </span>
              </div>
              <div className="box-select-limit">
                <BtnExport />
                <SelectLimit
                  limit={filters.limit}
                  setFilters={setFilters}
                  setReqData={setReqData}
                />
              </div>
            </div>
            <TableContent
              data={reqData.data.users}
              summary_total={reqData.data.summary_total}
            />
            <SelectPage
              totalPage={reqData.data.total_page}
              activePage={reqData.data.active_page}
              setFilters={setFilters}
              setReqData={setReqData}
            />
          </div>
        </div>
      );
    }

    if (showChart && reqData.data?.root_id) {
      content.push(
        <div key="org-chart" id="org-chart">
          <CreateChart
            userData={userData}
            orgData={{
              root_id: reqData.data.root_id,
              details: reqData.data.details,
              childs: reqData.data.childs,
              user_depts: reqData.data.user_depts,
              user_details: reqData.data.user_details,
              user_childs: reqData.data.user_childs,
              count_user_childrens: reqData.data.count_user_childrens,
              user_levels: reqData.data.user_levels ?? [] }}
            showFullnameAndPosition={showFullnameAndPosition}
          />
        </div>
      );
    }
  }

  return (
    <div key="main-content" id="main-content">
      <Btn
        setClearFilters={setClearFilters}
        setFilters={setFilters}
        defaultFilters={defaultFilters}
      />
      {content}
      <ModalViewStaff userData={userData} />
      <ModalExport />
      <ModalDownload />
      <div id="tmp-print"></div>
      <div id="preview-print"></div>
    </div>
  );
}


